import { Button } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import WarningModal from '@app/components/Modal/WarningModal';
import useDeleteBulkRequest from '@app/features/bulkRequest/hooks/useDeleteBulkRequest';
import useOpenErrorModal from '@app/hooks/useOpenErrorModal';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { modalClose } from '@app/store/modal/actions';

interface BulkRequestDeleteWarningModalProps {
  bulkRequestId: string;
}

function BulkRequestDeleteWarningModal({ bulkRequestId }: BulkRequestDeleteWarningModalProps) {
  const dispatch = useDispatch();

  const { createErrorHandler } = useOpenErrorModal();
  const workspaceId = useWorkspaceId();
  const { mutateAsync: deleteBulkRequest, isLoading } = useDeleteBulkRequest();

  return (
    <WarningModal
      cancelButton={<Button onClick={() => dispatch(modalClose())}>취소</Button>}
      closeButton={
        <Button
          isLoading={isLoading}
          ml={2}
          variant="primary"
          onClick={() => {
            deleteBulkRequest([workspaceId, bulkRequestId], {
              onSuccess: () => {
                dispatch(modalClose());
              },
              onError: createErrorHandler({
                title: '대량전송 삭제 실패',
              }),
            });
          }}
        >
          삭제하기
        </Button>
      }
      title="대량전송 삭제"
    >
      대량전송을 삭제하시겠습니까?
      <br />
      해당 내역을 다시 복구할 수 없습니다.
    </WarningModal>
  );
}

export default BulkRequestDeleteWarningModal;
